import React, { Fragment, useState, useEffect, useContext } from "react";
import { SessionContext } from '../context/sessionContext';

import { useHistory } from "react-router-dom";

import { Button } from "react-bootstrap";

import Footer from "./footer";

//EX 15-10-2026 (fase 3 - paso 2): el cascaron del formulario de ALTA. La estructura compartida con la
//edicion (barra de estado, encabezado con el titulo y los tres botones de pestaña, los tres tabs, la
//barra inferior con la leyenda, las 13 funciones de carga, el useEffect de errorD/errorCSP y el
//submButton) vive en layoutExpediente.js. Aca queda solo lo del alta: su titulo, sus dos botones de
//guardado, su fetch y su estado.
//Los imports que se sacan (Collapse, Form, FaExclamationTriangle, DatosExp, TramiteExp, Pestaña3_Exp,
//BarraEstadoFormulario) son justamente los que ahora renderiza el layout.
import LayoutExpediente from "./layoutExpediente";

import { toast } from "react-toastify";
import { construirPayload } from "./expedientePayload";
import useExpedienteForm from "../hooks/useExpedienteForm";

const Expediente = ({ setAuth, ...props }) => {

	const { getProfile, roleA, original, cambioOriginal, sesionT, geom, cambioGeom } = useContext(SessionContext);
	
	const name = roleA.username;
	const role = roleA.roleA;  	

	const form = useExpedienteForm({
		show: false,
		geomB: false,
		censos: [{ fechaCenso: null, cantidadHogares: "" }],
		boletos: {
		entregados: "",
		realizados: "",
		enProceso: "",
		enConflictoAdjudicatorio: "",//add 4-set-2025
		ultimaActualizacionBoletos: null,//add 4-set-2025
		fechaEntregaBoletos: null//add 4-set-2025
	},
		tramites: {
		realizados: "",
		enProceso: "",
		ultimaActualizacionTramites: "",//add 4-set-2025
	},
		observaciones_censo: "",
		inputs: {
		nombre_proyecto: "",//1
		expediente:"",//2
		fecha_carga: new Date(),//3 .toLocaleDateString('es-AR')
		fecha_caratulacion: null,//4
		fecha_actualizacion: null,
		//encargado:"",//5
		datos_05_responsable:"",//5
		tramite_prioritario:false,//6
		programa:"",//7
		estado:"",//8
		tipo:"",//9
		partido:0,// estado inicial tiene que ser un numero para que no de error en la base. Espera un integer//**10
		localidad:"",//11
		cantidad_lotes:null,//12
		cantidad_lotes_adjudicables:null,//13
		porc_lotes_municipales: null,//14
		lotes_adquiridos_municipio: null,//15
		datos_18_sintesis_nomenclatura:"",//18
		titular_tierra:"",//19
		plano_oficial:"",//20
		area:"",//21
		zonificacion:"",//22
		nro_ordenanza_vigente:"",//23
		decreto_promulgatorio:"",//24
		sistema_agua:"",//16
		eliminacion_excretas:"",//17
		observaciones_generales:"",//25
		id_exp_prueba:"",
		name: name,
		avanzados: false,

		datos_19_partido_nomencla:0,
		datos_20_circ_nomencla:"",
		datos_21_secc_nomencla:"",
		datos_22_geom : JSON.stringify(geom)		
	},
		formRows: [{
		nomenclatura_catastral:"000000000000000000000000000000000000000000",
		partida_inmobiliaria:"",//"000000",
		inscripcion_dominial:"",//"",
		nomencla_partido:"",//"000",
		nomencla_circ:"",//"00",
		nomencla_secc:"",//"00",
		nomencla_chacra_nro:"", nomencla_chacra_l:"",//"000",
		nomencla_quinta_nro:"", nomencla_quinta_l:"",//"000",
		nomencla_fracc_nro:"", nomencla_fracc_l:"",//"000",
		nomencla_manz_nro:"", nomencla_manz_l:"",//"000",
		nomencla_parc_nro:"", nomencla_parc_l:"",//"0000",
		solicitado:""
	 }],
		inputsTram: {

		solicitud_adhesion_t:false, //101 AGREGAR checkbox
		certif_urbanistico_municipal_t:false, //102
		certif_no_inundabilidad_t:false, //103
		anteproyecto_urbano_t:false, //104
		titulo_propiedad_t:false, //105

		informe_dominio_t:false, //106
		anotaciones_personales_t:false, //107
		admisibilidad_inicial_t:false, //108
		prefactibilidad_urbanistica_t:false, //109
		prefactibilidad_hidraulica_t:false, //110

		memoria_descriptiva_obras_t:false, //111
		energia_electrica_t:false, // 112

		agua_potable_t:false, //113
		eliminacion_excretas_t:false, //114
		apertura_calles_t:false, //115
		acta_constitutiva_t:false, //116
		certif_vigencia_persona_juridica_t:false, //117
		plano_mensura_t:false, //118
		convenio_urbanistico_t:false, //119
		ordenanza_municipal_t:false, //120
		memoria_descriptiva_procedimientos_t:false, //121

		certif_tecnico_urbanistico_t:false, //122
		resolucion_afectacion_t:false, //123
		visado_plano_t:false, //124

		observaciones_internas_t:"", //125
		observaciones_reporte_t:"", //126

		t_127_tramitacion_ada_prefac_h:"", //127
		fecha_envio_prefac_h_t: null, //128 - 05-04-22 - CAMBIO para PREFACTIBILIDAD HIDRÁULICA
		expediente_prefac_h_t: "", //129 - volver a agregar
		fecha_emision_prefac_h_t: null, //130 - 05-04-22 - CAMBIO para PREFACTIBILIDAD HIDRÁULICA
		t_131_observaciones_prefact_h:"", //131

		t_132_tramitacion_resol:null, //132

		fecha_envio_resol_t: null, //133 - CAMBIO 05-04-22
		fecha_emision_resol_t: null, //134 - CAMBIO 05-04-22
		numero_especial_resol_t:"", //135
		t_136_observaciones_resol:"", //136

		t_137_tramitacion_visado:"", //137
		fecha_visado_plano_t: null, //138 - CAMBIO 05-04-22
		t_139_fecha_entrega: null, //139 - ADD 20-09-2022
		t_140_observaciones_tramitacion:"", //140 - ADD 20-09-2022
		t_144_proyecto_hidraulico: false, //144 -- add 22-12-2022
		t_145_cpu_tramitacion:"", //145 --add 14-JUN-2024
		t_146_cpu_fecha_envio: null, //146 --add 14-JUN-2024
		t_147_cpu_fecha_emision: null, //147 --add 14-JUN-2024
		t_148_cpu_nro_gdeba:"", //148 --add 14-JUN-2024
		t_149_cpu_observaciones:"" //149 --add 14-JUN-2024
	},
		inputsCSP: {

		csp_1_tamaño_medio_lotes_residenciales : null,
		csp_2_actor_encargado_obras_infra : "",
		csp_3_financiamiento_publico_obras_infra: false, 	//check
		csp_4_jurisdiccion_infra : "",
		csp_5_organismo_financiamiento_infra : "",

		csp_6_fecha_control_infra : null,//date
		csp_7_descripcion_obras_infra : "",

		csp_8_financiamiento_publico_obras_viv: false, 	//check
		csp_9_jurisdiccion_viv : "",
		csp_10_organismo_financiamiento_viv : "",

		csp_11_fecha_control_viv: null, //date
		csp_12_descripcion_obras_viv : "",

		csp_13_financiamiento_publico_obras_equip: false, 	//check
		csp_14_jurisdiccion_equip : "",
		csp_15_organismo_financiamiento_equip : "",

		csp_16_fecha_control_equip: null, //date

		csp_17_descripcion_obras_equip : "",
		csp_18_pl_mensura_estado : "",
		csp_19_pl_mensura_partido : "",
		csp_20_pl_mensura_orden : "",
		csp_21_pl_mensura_año : "",

		csp_22_pl_mensura_fecha: null, //date

		csp_23_registracion_legajo : null,
		csp_24_registracion_folio : null,

		csp_25_registracion_fecha: null, //date
		csp_26_fecha_control: null, //date

		csp_27_observaciones_csp : "",

		csp_28_presencia_apertura_calles:"",
		csp_29_parc_edificadas:null,
		csp_30_porcentaje_parc_edificadas:null,
		csp_31_observ_seguimiento_obras_y_edificacion : "",
		csp_32_fecha_control_seguimiento_obras:null //date
	},
		errorD: true,
		errorCSP: false,
		resultError: undefined,
		openExpediente: true,
		openTramite: false,
		openPestaña3: false,
	});
	//EX 15-10-2026 (fase 3 - paso 2): el cascaron usa del hook solo estos nombres. El resto (los setters
	//de los tabs, los tres open*, errorD/errorCSP, show y geomB) los usa el layout, que recibe el objeto
	//entero en la prop form. Los de aca son los que necesitan el payload del guardado, los botones de
	//guardar y el efecto de la geometria.
	const {
		inputs, setInputs,
		inputsTram, inputsCSP,
		boletos, tramites, formRows, observaciones_censo, censos,
		resultError,
		setGeomB,
	} = form;

	const history = useHistory();

	//EX 18-09-2026: la geometria del contexto ahora es UNICA (antes el alta tenia la suya y la edicion
	//la suya, en geomEdit). Con un solo estado, si la ultima pantalla que dibujo fue la edicion de otro
	//expediente (o el Monitor, que tambien escribe esa clave), esta alta arrancaria con ESE poligono
	//cargado: el mapa inicializa su estado desde el contexto (map_expedientes.js). Se limpia al montar,
	//igual que hace la edicion al abrir la ficha.
	//Solo al montar: "Guardar y Continuar" no remonta el componente, asi que la geometria se conserva.
	useEffect(()=>{
		cambioGeom({type:"FeatureCollection",features:[{"type":"Feature","properties":{},"geometry":{}}]});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(()=>{
		setInputs({ ...inputs, datos_22_geom: JSON.stringify(geom) });
		setGeomB(true);	
	}, [geom])

	useEffect(() => {
		const pagina = 'acceso_pagina';
		
		getProfile(pagina);
		if(sesionT === 'no_token'){
			console.log('#82 - volver a loguear');
		} else if( sesionT === 'Token valido'){
			console.log("#71--> ","token valido" );
		}
		
	}, []);
	//*** cierra chequear token ****//24-06-2022
	
  	//***Guardar y Salir
	const redirect = async e => {
		try{
			const x = 'nuevo';
			//getProfile(x);
		if(sesionT === 'no_token'){
			alert('volver a loguear');
		} else if( sesionT === 'Token valido'){
			//console.log("92--> ","token valido" );
			saveExit(e);// si el token es válido, ejecutar saveExit
		}

		} catch(err){
			console.error(err);
		}
	}

  	//***Guardar y Continuar*** 06/10/2022
	const redirect_Cont = async e => {
		e.preventDefault();
		try{
			const x = 'nuevo';
			if(sesionT === 'no_token'){
				alert('volver a loguear');
			} else if( sesionT === 'Token valido'){
				saveSeguir(e);// si el token es válido, ejecutar saveExit
			}
		} catch(err){
			console.error(err);
		}		
	}

	const [estadoExp, setEstadoExp]=useState("nuevo");

	//nuevos 28-marz-2025
	//console.log("CENSOS", censos)
	//console.log("boletos", boletos)
	//console.log("tramites", tramites)
	//console.log("observaciones_censo", observaciones_censo)

	//cierra nuevos

	//**Estados de TRAMITES

	//**crear estado para datos de la Pestaña 3 (Seguimiento)
	//**primero los inputs CSP

	//**10jul24 */

	const {
		id_exp_prueba,
		nombre_proyecto, 
		fecha_carga,
		fecha_caratulacion,
		fecha_actualizacion, //add 25-abr-2024
		datos_05_responsable, tramite_prioritario, avanzados, expediente, programa, estado,
		tipo, partido, localidad, cantidad_lotes, cantidad_lotes_adjudicables,
		lotes_adquiridos_municipio, porc_lotes_municipales,
		datos_18_sintesis_nomenclatura,
		titular_tierra, plano_oficial,
		area, zonificacion, nro_ordenanza_vigente, decreto_promulgatorio, sistema_agua, eliminacion_excretas,
		observaciones_generales,
		datos_19_partido_nomencla, datos_20_circ_nomencla, datos_21_secc_nomencla,
		datos_22_geom
	} = inputs;
	
	const {
		solicitud_adhesion_t,
		certif_urbanistico_municipal_t, certif_no_inundabilidad_t, anteproyecto_urbano_t,
		titulo_propiedad_t, memoria_descriptiva_obras_t, energia_electrica_t, prefactibilidad_urbanistica_t,
		agua_potable_t, eliminacion_excretas_t, apertura_calles_t, acta_constitutiva_t, certif_vigencia_persona_juridica_t,
		plano_mensura_t, convenio_urbanistico_t, ordenanza_municipal_t, memoria_descriptiva_procedimientos_t, informe_dominio_t,
		anotaciones_personales_t, admisibilidad_inicial_t, prefactibilidad_hidraulica_t, certif_tecnico_urbanistico_t,
		resolucion_afectacion_t, visado_plano_t,
		observaciones_internas_t,//125
		observaciones_reporte_t,//126
		fecha_envio_prefac_h_t, expediente_prefac_h_t, fecha_emision_prefac_h_t,
		fecha_visado_plano_t, fecha_envio_resol_t, fecha_emision_resol_t, numero_especial_resol_t,
		t_127_tramitacion_ada_prefac_h,
		t_131_observaciones_prefact_h,
		t_132_tramitacion_resol,
		t_136_observaciones_resol,
		t_137_tramitacion_visado,
		t_139_fecha_entrega, //139 - ADD 20-09-2022
		t_140_observaciones_tramitacion, //140 - ADD 20-09-2022
		t_144_proyecto_hidraulico, //144 -- add 22-12-2022
		t_145_cpu_tramitacion, //145 --add 14-JUN-2024
		t_146_cpu_fecha_envio, //146 --add 14-JUN-2024
		t_147_cpu_fecha_emision, //147 --add 14-JUN-2024
		t_148_cpu_nro_gdeba, //148 --add 14-JUN-2024
		t_149_cpu_observaciones //149 --add 14-JUN-2024
	}= inputsTram;
	
	const saveExit = async e => {
		e.preventDefault();

		const censosEnviar = censos.map(item => {
			let fechaFormateada = item.fechaCenso;
			
			// Si es un objeto Date
			if (fechaFormateada instanceof Date) {
				fechaFormateada = fechaFormateada.toISOString().split('T')[0];
			}
			// Si es un string ISO (contiene 'T')
			else if (typeof fechaFormateada === 'string' && fechaFormateada.includes('T')) {
				fechaFormateada = fechaFormateada.split('T')[0];
			}
			// Si ya está en formato YYYY-MM-DD o es null/undefined, lo dejamos igual			
			return {
				...item,
				fechaCenso: fechaFormateada
			};
		});

		try {
			const body = construirPayload({
				...inputs, ...inputsTram, ...inputsCSP,
				inputsCSP, boletos, tramites, formRows, observaciones_censo, censosEnviar, estadoExp, name,
			}, { id_exp_prueba });

			const response = await fetch(
				`/api/authentication/new_expediente`, 
				{
					method: "POST",
					headers: {
							"Content-type": "application/json"
					},
					body: JSON.stringify(body)
				}
			);

			const parseRes = await response.json();
			
			if (parseRes.id === undefined){ //cuando el estado es 'nuevo' y se ingresa un expediente que ya existe
				toast.error(`El expediente ya existe, intente nuevamente.`);
			} else if (parseRes.id !== undefined && parseRes.id === parseRes.id_exp_prueba){
				toast.success(`Expediente ${parseRes.expediente} creado correctamente!!`);
				cambioGeom({type:"FeatureCollection",features:[{"type":"Feature","properties":{},"geometry":{}}]})
				history.replace('/inicio'); //si la respuesa es OK, ahora salir
			} else if (parseRes.id !== parseRes.id_exp_prueba && parseRes.id !== 'error'){
				setEstadoExp("nuevo");
				toast.success(`Expediente ${parseRes.expediente} actualizado correctamente!!`);
				//EX 21-09-2026: mismo arreglo que en la edicion: la fecha de actualizacion que devuelve el
				//server tiene que llegar al estado, que es de donde la lee el Tab 1.
				setInputs({ ...inputs, fecha_actualizacion: parseRes.fecha_actualizacion });
				history.replace('/inicio');
			} else if (parseRes.id=== 'error' && parseRes.message === 'Ha ocurrido un error al insertar expediente'){//viene de nuevo expediente
				toast.error(`Ocurrió un error al crear el expediente, por favor intente nuevamente. Si el problema continua comunicarse con un administrador`);

			} else if (parseRes.id=== 'error' && parseRes.message === 'Ha ocurrido un error'){
				toast.error(`Ocurrió un error, por favor intente nuevamente. Si el problema continua comunicarse con un administrador.`);

			} else {
				toast.error(`Ocurrió un problema al crear el expediente, intente nuevamente.`);
			}

		} catch (err) {
			console.error(err.message);
		}
	};

	const saveSeguir = async e => {
		e.preventDefault();

		const censosEnviar = censos.map(item => {
			let fechaFormateada = item.fechaCenso;
			
			// Si es un objeto Date
			if (fechaFormateada instanceof Date) {
				fechaFormateada = fechaFormateada.toISOString().split('T')[0];
			}
			// Si es un string ISO (contiene 'T')
			else if (typeof fechaFormateada === 'string' && fechaFormateada.includes('T')) {
				fechaFormateada = fechaFormateada.split('T')[0];
			}
			// Si ya está en formato YYYY-MM-DD o es null/undefined, lo dejamos igual	
			return {
				...item,
				fechaCenso: fechaFormateada
			};
		});

		try {
			const body = construirPayload({
				...inputs, ...inputsTram, ...inputsCSP,
				inputsCSP, boletos, tramites, formRows, observaciones_censo, censosEnviar, estadoExp, name,
			}, { id_exp_prueba, fecha_actualizacion });

			const response = await fetch(				
            	`/api/authentication/new_expediente`, 
					{
						method: "POST",
						headers: {
							"Content-type": "application/json"
						},
						body: JSON.stringify(body)
						//body2: JSON.stringify(body2)
					}
				);

			const parseRes = await response.json();

			if (parseRes.id === undefined){ //cuando el estado es 'nuevo' y se ingresa un expediente que ya existe
				toast.error(`El expediente ya existe, intente nuevamente.`);

			} else if (parseRes.id !== undefined && parseRes.id === parseRes.id_exp_prueba){
				setEstadoExp("edicion");
				setInputs({	...inputs, id_exp_prueba : parseRes.id_exp_prueba, fecha_actualizacion: parseRes.fecha_actualizacion});
				toast.success(`Expediente ${parseRes.expediente} creado correctamente!!`);
				cambioOriginal(0);

			} else if (parseRes.id !== parseRes.id_exp_prueba && parseRes.id !== 'error'){
				toast.success(`Expediente ${parseRes.expediente} actualizado correctamente!!`);
				//EX 21-09-2026: mismo arreglo que en la edicion: la fecha de actualizacion que devuelve el
				//server tiene que llegar al estado, que es de donde la lee el Tab 1.
				setInputs({ ...inputs, fecha_actualizacion: parseRes.fecha_actualizacion });
				cambioOriginal(0);

			} else if (parseRes.id=== 'error' && parseRes.message === 'Ha ocurrido un error al EDITAR expediente'){
				toast.error(`Ocurrió un error al editar el expediente.`);
			} else if (parseRes.id=== 'error' && parseRes.message === 'Ha ocurrido un error'){
				toast.error(`Ocurrió un error, por favor intente nuevamente. Si el problema continua comunicarse con un administrador`);
			} else {
				toast.error(`Ocurrió un problema al crear el expediente, por favor intente nuevamente.`);
			}
		} catch (err) {
			console.error(err.message);
		}
	};

	//EX 18-09-2026: estado actual del formulario, para la barra superior (la leyenda la ve solo admin).
	//Se deriva del dato real (si el expediente ya tiene id_exp_prueba, existe en la base), que es la
	//misma regla que va a usar la maquina de estados de la unificacion alta/edicion.
	const estadoFormulario = inputs.id_exp_prueba ? "EDICIÓN" : "NUEVO";

	//EX 18-09-2026: Cancelar en el alta. La pantalla de edicion ya lo tenia y esta no: sale del
	//formulario sin guardar.
	//Dos cosas importantes al salir:
	// - se limpia la geometria dibujada del contexto global (si no, el poligono quedaria cargado para
	//   la proxima alta; es la misma limpieza que se hace despues de guardar);
	// - cambioOriginal(0) para volver a dejar los botones de guardar en desactivado, igual que en el
	//   cancelar de la edicion.
	const cancelarAlta = (e) => {
		e.preventDefault();
		if(!window.confirm("¿Salir sin guardar el expediente?")){
			return;
		}
		cambioGeom({type:"FeatureCollection",features:[{"type":"Feature","properties":{},"geometry":{}}]});
		cambioOriginal(0);
		history.replace('/inicio');
	}

  	return (
		<Fragment>

			{/*EX 15-10-2026 (fase 3 - paso 2): el cascaron del formulario se fue al layout compartido con
			   la edicion. Aca queda lo propio del ALTA: el titulo, los dos botones de guardado y el estado
			   del formulario (que es el que define la barra: NUEVO o EDICIÓN segun inputs.id_exp_prueba).
			   Los botones viajan como JSX en la prop 'botones' y caen en el MISMO lugar donde estaban
			   (adentro de .flexbox-container, antes de la leyenda). Van envueltos en un Fragment, que no
			   agrega ningun elemento al DOM: quedan hermanos, igual que antes.
			   OJO: el <div className="main"> y el <Footer/> NO son del layout a proposito. Son chrome de
			   PAGINA y .container_todo es flex column con min-height:100vh, asi que el footer tiene que
			   quedar HERMANO de .main (patron sticky-footer-with-flexbox, ver index.css:74 y 208).*/}
			<div className="main" >

				<LayoutExpediente
					form={form}
					name={name}
					titulo="Nuevo Expediente"
					estadoFormulario={estadoFormulario}
					onCancelar={cancelarAlta}
					botones={
						<Fragment>
							<Button form='my-form' type="button" disabled={ role ==="visualizador" || role==="user" || original ===0 || sesionT ==='no_token' || resultError===true ? true : false } className="btn btn-success btn-block button_verde" onClick={redirect_Cont}>Guardar y Continuar</Button> {/*era Submit */}
							<Button type="button" id="but_new_save_e2" disabled={ role ==="visualizador" || role==="user" || original ===0 || sesionT ==='no_token' || resultError===true ? true : false } className="btn btn-success btn-block button_verde" onClick={redirect}>Guardar y Salir</Button>
						</Fragment>
					}
				/>
			</div> {/* cierra el Main */}

			<Footer/>
		</Fragment>
  	);
};

export default Expediente;
